<template>
  <div>
    <!-- 活动管理二期优化 - 20200228 -->
    <div>
      <span class="xbed-sub-title">活动管理</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>活动管理</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label='活动标题:' :label-width='100'>
        <Input type='text' v-model.trim="queryKeyWords.title" style="width:200px;"></Input>
      </FormItem>
      <FormItem label='活动状态:' :label-width='100'>
				<Select v-model="queryKeyWords.state" filterable>
					<Option :value="-1">全部</Option>
					<Option :value="2">启用</Option>
					<Option :value="3">停用</Option>
				</Select>
			</FormItem>
      <FormItem label='有效日期:' :label-width="100">
        <DatePicker type="daterange" :editable="false" v-model="effectiveDate" format="yyyy-MM-dd" placeholder="单选日期/日期段" style="width: 250px"></DatePicker>
      </FormItem>
      <br/>
      <FormItem :label-width="25">
        <Button type="primary" @click="changeQueryKeyWord">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleActivityDetail()">新增活动</Button>
      </FormItem>
      <Content>
        <Table stripe :columns="columnsList" :data='dataList' :loading='cardListLoading'></Table> <!-- style='width:1533px' -->
        <div style="margin: 10px;overflow: hidden">
          <Page show-sizer show-total :page-size="queryKeyWords.size" :current="queryKeyWords.page" :total="listTotal" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </Content>
    </Form>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
import Moment from "moment";
export default {
  created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userId = Utils.findFromLocalStorage( "vue-userid" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
    }
	},
  data () {
    return {
      queryKeyWords:{
        page:1,
        size:10,
        state: -1, // 活动状态 --2 启用 --3 停用
        title:'', // 活动标题
        effectiveBeginDate: '', // 有效开始时间
        effectiveEndDate: '' // 有效结束日期
      },
      effectiveDate: [], // 有效日期
      dataList: [],
      listTotal: 0,
      cardListLoading:false,
      columnsList:[
        {
          title:'ID',
          key:'activityId',
          align:'center',
          width:100
        },
        {
          title:'活动标题',
          key:'title',
          align:'center',
          width:200,
          render: (h, params) => {
            return h('span', {
              style: {
                overflow: 'hidden',
                webkitLineClamp: 5,
                webkitBoxOrient: 'vertical',
                wordBreak: 'break-all',
                display: '-webkit-box',
                margin: '8px 0'
              },
              attrs: {
                title: params.row.title
              }
            }, params.row.title)
          }
        },
        {
          title:'描述',
          key:'describes',
          align:'center',
          width:300,
          render: (h, params) => {
            return h('span', {
              style: {
                overflow: 'hidden',
                webkitLineClamp: 5,
                webkitBoxOrient: 'vertical',
                wordBreak: 'break-all',
                display: '-webkit-box',
                margin: '8px 0'
              },
              attrs: {
                title: params.row.describes
              }
            }, params.row.describes)
          }
        },
        {
          title:'有效日期',
          align:'center',
          width:300,
          render:(h,params)=>{
            const date = params.row.type == 1 ? '不限时' : params.row.beginDatetime ? `${Moment( params.row.beginDatetime ).format( "YYYY年MM月DD日" )} - ${Moment( params.row.endDatetime ).format( "YYYY年MM月DD日" )}` : '-'
            return h('div', {}, date)
          }
        },
        {
          title:'奖励类型',
          align:'center',
          width:150,
          render: (h, params) => {
            let type = '-'
            switch (params.row.activityRewardType) {
              case 1:
                type = '预订金额折扣'
                break;
              case 2:
                type = '预订金额减免'
                break;
              case 3:
                type = '赠送优惠券'
                break;
              case 4:
                type = '赠送积分'
                break;
              case 5:
                type = '预订房晚兑换'
                break;            
              default:
                break;
            }
            return h('span', {}, type)
          }
        },
        {
          title:'状态',
          align:'center',
          width:100,
          render: (h, params) => {
            const status = ['','','启用','停用'][params.row.state]
            return h('span', {}, status)
          }
        },
        {
          title:'已参与人数',
          key:'userUseCount',
          align:'center',
          width:120,
        },
        {
          title:'产品限制',
          align:'center',
          width:150,
          render: (h, params) => {
            // return h('span', {}, ['无限制', '门店', '城市', '无限制（剔除部分门店）'][params.row.productLimit])
            return h('div', [
              h('span', {}, ['无限制', '门店', '城市', '无限制', '城市'][params.row.productLimit]),
              h('span', {
                style: {
                  display: (params.row.productLimit === 3 || params.row.productLimit === 4) ? 'block' : 'none'
                }
              }, '（剔除部分门店）'),
            ])
          }
        },
        {
          title:'用户限制',
          align:'center',
          width:120,
          render: (h, params) => {
            return h('span', {}, ['无限制', '用户标签'][params.row.userLimit])
          }
        },
        {
          title:'订单限制',
          align:'center',
          width:120,
          render: (h, params) => {
            return h('span', {}, ['无限制', '订单类型', '入住房晚'][params.row.orderLimit])
          }
        },
        {
          title:'操作',
          key:'id',
          align:'center',
          width:150,
           render:(h,params) => {
            return h('div',
            [
              h('Button',{
                props:{
                  type:'primary',
                  size:'small'
                },
                style:{
                  margin:'3px'
                },
                on:{
                  click:()=>{
                    this.handleActivityDetail(params.row.activityId)
                  }
                }
              },'详情'),
              h('Button',{
                props:{
                  type:'error',
                  size:'small'
                },
                style:{
                  marginLeft:'3px'
                },
                on:{
                  click:()=>{
                    if ( !Utils.hasPermission( 'acticity_del' ) ) {
                      this.$Notice.error( {
                        title: "无权限操作"
                      } );
                      return
                    }
                    if ( params.row.state === 2 ) {
                      this.$Notice.warning( {
                        title: "活动启用中，请先停用活动"
                      } );
                      return
                    }
                    this.$Modal.confirm({
                      title:'消息提醒',
                      content: `确定删除<span style='color:red;font-size:14px;'>${params.row.title}</span>吗？ \n 一经确定，无法修改！`,
                      okText:'确定',
                      cancelText:'取消',
                      onOk:()=>{
                        this.deleteBtn(params.row.activityId)
                      }
                    })
                  }
                }
              },'删除')
            ])
          }
        },
      ],
    }
  },
  mounted () {
    this.$Notice.config({
			top: 200
		});
    this.querActityList()
  },
  methods: {
    async querActityList(){
      if ( !Utils.hasPermission( 'acticity_list' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
      }
      this.cardListLoading = true

      let params = this.queryKeyWords
      params.effectiveBeginDate = this.effectiveDate && this.effectiveDate[0] ? Moment( this.effectiveDate[0] ).format( "YYYY-MM-DD" ) : ''
      params.effectiveEndDate = this.effectiveDate && this.effectiveDate[0] ? Moment( this.effectiveDate[1] ).format( "YYYY-MM-DD" ) : ''

      // 过滤空字段
      params = Object.keys(params).reduce(function(c, k) {
        if (params[k] && params[k] !== -1) {
          c[k] = params[k]
        }
        return c
      }, {})

      try {
        let resp = (await API.omsAPI[this.env].clientServer.getActivityList(params, this.protHeaders)).data;
        this.cardListLoading = false
        if ( resp.retCode ) {
          this.$Notice.error({
            title: '获取活动管理数据失败',
            desc: resp.msg
          })
          return
        }
        this.dataList = resp.content || []
        this.listTotal = resp.total
      } catch (e) {
        this.cardListLoading = false
        this.$Notice.error({
					title: '服务器异常，请稍后再试'
				})
      }
    },
    changeQueryKeyWord(){
      this.queryKeyWords.page = 1
			this.querActityList();
    },
    changePageSize(pageSize){
      this.queryKeyWords.size = pageSize
      this.queryKeyWords.page = 1
      this.querActityList()
    },
    changePage(page){
      this.queryKeyWords.page = page
      this.querActityList()
    },

    // 删除操作
    async deleteBtn(activityId){
      let params = {
        activityId,
        userId: this.userId
      }
      let resp = (await API.omsAPI[this.env].clientServer.deleteActivity(params, this.protHeaders)).data;
      if (resp.retCode){
        this.$Notice.error({
          title: "删除失败",
          desc: resp.msg
        });
        return
      }
      this.$Notice.success({
        title: "删除成功",
        desc: resp.msg
      });
      this.querActityList()
    },

    // 新增/编辑 跳转
    handleActivityDetail(actityId) {
      if ( !Utils.hasPermission( 'acticity_editView' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      let _url = this.$router ? '#/app/marketing/activityEditView' : '#/Market/Market/activityEditView'
      if (actityId) {
        localStorage.setItem("actityId", actityId)
      } else {
        localStorage.removeItem("actityId")
      }
      window.open(_url)
    },
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/marketing/activityList.vue